import { memo } from "react";

import Checkbox from "src/components/Checkbox/Checkbox";
import TrackedAnchor from "src/components/TrackedAnchor/TrackedAnchor";

export interface Props {
  termsAccepted: boolean;
  setTermsAccepted(value: boolean): void;
  className?: string;
}

const Terms = ({ termsAccepted, setTermsAccepted, className }: Props) => (
  <div className={className}>
    <Checkbox id="accept-terms" value={termsAccepted} onChange={setTermsAccepted} />
    <label htmlFor="accept-terms">
      {"I accept "}
      <TrackedAnchor
        rel="noreferrer"
        target="_blank"
        href="https://k8slens.dev/licenses/tos"
      >
        Lens Terms of Service
      </TrackedAnchor>
      {" and "}
      <TrackedAnchor
        rel="noreferrer"
        target="_blank"
        href="https://www.mirantis.com/company/privacy-policy/"
      >
        Privacy Policy
      </TrackedAnchor>
      .
    </label>
  </div>
);

export default memo(Terms);
